export default __webpack_public_path__ + "static/media/openmarkets.5c9de159.png";